import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Button from '@material-ui/core/Button';

import CSVUploadDialog from 'hcla-web-frontend-primitives/app/components/primitives/Dialogs/CSVUploadDialog';

const styles = theme => ({
  paramsContainer: {
    border: '1px solid #ccc',
    borderTop: 'none',
    background: '#e8e8e8',
    borderRadius: `0px 0px ${theme.spacing.unit / 2}px ${theme.spacing.unit / 2}px`,
    padding: '8px',
    overflowY: 'auto',
    minHeight: '150px',
    height: 'calc(100vh - 695px)',
  },
  addButtonHeader: {
    borderRadius: `${theme.spacing.unit / 2}px ${theme.spacing.unit / 2}px 0px 0px`,
    display: 'flex',
    overflow: 'hidden',
    flexDirection: 'row',
    marginTop: `${theme.spacing.unit / 2}px`,
    justifyContent: 'space-evenly',
  },
  menuButton: {
    borderRadius: '0px',
    width: '82px',
  },
});

class LikelihoodParams extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      openDialog: false,
    };
  }

  handleOpen = () => {
    this.setState({ openDialog: true });
  };

  handleClose = (e) => {
    this.setState({ openDialog: false });
  };

  processCsvData = (data) => {
    const list = [];
    data.forEach((element) => {
      if (!Number.isNaN(parseFloat(element[0])) && !Number.isNaN(parseFloat(element[1]))) {
        list.push([Number(element[0]), Number(element[1])]);
      }
    });
    this.props.addList(null, list);
    this.setState({
      openDialog: false,
    });
  };

  render() {
    const {
      classes, options, suggestions, addValue,
    } = this.props;

    return (
      <div>
        {suggestions}
        <AppBar position="static" className={classes.addButtonHeader}>
          <Button
            className={classes.menuButton}
            color="inherit"
            onClick={this.handleOpen}
          >
            CSV
          </Button>
          <CSVUploadDialog
            open={this.state.openDialog}
            onFileLoaded={this.processCsvData}
            onRequestClose={e => this.handleClose(e)}
          />
        </AppBar>
        <div className={classes.paramsContainer}>
          {options}
        </div>
      </div>
    );
  }
}

LikelihoodParams.propTypes = {
  options: PropTypes.instanceOf(Object).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  suggestions: PropTypes.instanceOf(Object).isRequired,
  addValue: PropTypes.instanceOf(Function).isRequired,
  onAddLikelihoodParamsComponentResult: PropTypes.instanceOf(Function).isRequired,
  onRemoveLikelihoodParamsComponentResult: PropTypes.instanceOf(Function).isRequired,
  addList: PropTypes.instanceOf(Function).isRequired,
};

export default withStyles(styles)(LikelihoodParams);
